import React from 'react';
import PropTypes from 'prop-types';

import styles from '../common-status-style.module.less';

const WarningCurrencySegment = ({ currencyCode }) => {
  return <span className={styles['message-currency-code']}>{currencyCode}</span>;
};

WarningCurrencySegment.propTypes = {
  currencyCode: PropTypes.string.isRequired,
};

export default WarningCurrencySegment;
